import { useCallback } from "react";
import { SquiggleTypes } from "../types/types";
import { useOpenItemsContext } from "../context/OpenItemsContext";

export const useAddItemGlue = () => {
  const { addOpenItem, setSelectedItemId } = useOpenItemsContext();

  const addNewItem = useCallback((type: SquiggleTypes, parentId: string|undefined, defaultName?: string) => {
    const newId = '*' + Date.now();
    addOpenItem({
      id: newId,
      type,
      sortTimestamp: 0,
      name: defaultName ?? '',
      text: '',
      links: [],
      aliases: [],
      archived: false,
      images: [],
      parent: parentId
    });
    setSelectedItemId(newId);
  }, [addOpenItem, setSelectedItemId]);

  const addQuest = useCallback((parentId: string|undefined, defaultName?: string) => addNewItem('quest', parentId, defaultName), [addNewItem]);
  const addPersonOrOrg = useCallback((parentId: string|undefined, defaultName?: string) => addNewItem('personororg', parentId, defaultName), [addNewItem]);
  const addPlace = useCallback((parentId: string|undefined, defaultName?: string) => addNewItem('place', parentId, defaultName), [addNewItem]);
  const addMiscItem = useCallback((parentId: string|undefined, defaultName?: string) => addNewItem('miscitem', parentId, defaultName), [addNewItem]);
  const addLogEntry = useCallback((parentId: string|undefined, defaultName?: string) => addNewItem('logentry', parentId, defaultName), [addNewItem]);
  
  return { addNewItem, addQuest, addPersonOrOrg, addPlace, addMiscItem, addLogEntry };
};